module.exports = __webpack_public_path__ + "home-partner-mockup@2x.1OIthNHg.png";